"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FusePipesModule = /** @class */ (function () {
    function FusePipesModule() {
    }
    return FusePipesModule;
}());
exports.FusePipesModule = FusePipesModule;
